import { render } from "./DocumentsNewsBlockControl.vue?vue&type=template&id=23a4b024"
import script from "./DocumentsNewsBlockControl.vue?vue&type=script&lang=js"
export * from "./DocumentsNewsBlockControl.vue?vue&type=script&lang=js"

import "./DocumentsNewsBlockControl.vue?vue&type=style&index=0&id=23a4b024&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__